function formatNumber(val: number) {
    if (val < 10) {
        return '0' + val;
    }
    return `${val}`;
}

/**
 * 获取日期格式输出
 * @param  {Date}   time   时间
 * @param  {String} format 输出格式，要求必须含有yyyy,mm,dd
 * @return {String}        默认返回yyyymmdd格式时间
 */
export function getTimeStr(
    time: Date | string | number,
    format = 'yyyy-MM-dd',
) {
    if (typeof time === 'string') {
        time = new Date(+time);
    } else if (typeof time === 'number') {
        time = new Date(time);
    }
    return (
        format
            // @ts-ignore
            .replace('yyyy', time.getFullYear())
            .replace('MM', formatNumber(time.getMonth() + 1))
            .replace('dd', formatNumber(time.getDate()))
            .replace('HH', formatNumber(time.getHours()))
            .replace('mm', formatNumber(time.getMinutes()))
            .replace('SS', formatNumber(time.getSeconds()))
    );
}

// 毫秒转换时分秒
export function formatTimeSecs(milliseconds: number) {
    const hours = Math.floor(milliseconds / 1000 / 3600);
    const minutes = Math.floor((milliseconds / 1000 % 3600) / 60);
    const secs = Math.floor(milliseconds / 1000 % 60);
    
    return (hours + '时' + minutes + '分' + secs + '秒');
}
